<div class="advanced-setting-continer">
    <!-- Header -->
    <div class="header">
        <!-- Titles -->
        <div class="titles">
            <div class="title main-title">
                <span class="highlighted">{{ getChannelTag() }}</span>
                {{ getChannelName() }}
            </div>
            <div class="subtitle group-title">
                {{ groupName }}
            </div>
        </div>
        <!-- Buttons -->
        <div class="buttons">
            <!-- <button class="border" (click)="handleExitClicked()">Exit without saving</button> -->
            <button class="cancel-button" (click)="emitExit()">
                {{ "forms.channel.advanced.button.cancel" | translate }}
            </button>
            <button
                class="save-button primary"
                (click)="handleSaveClicked()"
                [disabled]="!isFormValid() || !hasUnsavedChanges()"
            >
                {{ "forms.channel.advanced.button.save" | translate }}
            </button>
        </div>
    </div>

    <div class="input-area">
        <!-- Value Range (Analog) -->
        <div #range>
            <div class="advanced-group alarm-range-container">
                <div class="range-container">
                    <app-channel-alarm-range
                        [channel]="channel"
                        [value]="getRawValue()"
                    ></app-channel-alarm-range>
                </div>

                <div class="range-flex">
                    <!-- Measurable Range Min -->
                    <div>
                        <div class="text bold highlighted">
                            {{
                                "forms.channel.advanced.labels.minimum-range"
                                    | translate
                            }}
                        </div>
                        <div class="range-input">
                            <input
                                type="text"
                                class="text"
                                scaledNumericInput
                                (onScaledInput)="handleRangeMinChange($event)"
                                [scale]="getScale()"
                                [scaleValue]="getMeasurableRangeMin()"
                            />
                        </div>

                        <app-validation-error-label
                            *ngIf="getMeasurableRangeMinErrorString()"
                            [message]="getMeasurableRangeMinErrorString()"
                        ></app-validation-error-label>
                    </div>

                    <!-- Space Elements -->
                    <div style="flex: 1"></div>

                    <!-- Measurable Range Max -->
                    <div class="range-right-align">
                        <div class="text bold highlighted">
                            {{
                                "forms.channel.advanced.labels.maximum-range"
                                    | translate
                            }}
                        </div>
                        <div class="range-input">
                            <input
                                type="text"
                                class="text"
                                scaledNumericInput
                                (onScaledInput)="handleRangeMaxChange($event)"
                                [scale]="getScale()"
                                [scaleValue]="getMeasurableRangeMax()"
                            />
                        </div>
                        <app-validation-error-label
                            *ngIf="getMeasurableRangeMaxErrorString()"
                            [message]="getMeasurableRangeMaxErrorString()"
                        ></app-validation-error-label>
                    </div>
                </div>
                <app-alarm-range-list [channel]="editedChannel">
                </app-alarm-range-list>

                <div>
                    <app-validation-error-label
                        *ngIf="hasAlarmValidationErrors()"
                        [message]="
                            'forms.channel.advanced.errors.alarm-settings.invalid-alarms'
                                | translate
                        "
                    ></app-validation-error-label>
                </div>
            </div>
        </div>

        <!-- Value Range (Digital) -->
        <div *ngIf="!shouldShowValueSlider()" class="text-large bold">
            {{ getDisplayValue() }}
        </div>

        <!-- Unit -->
        <div class="input-group" *ngIf="!isDigital()">
            <div class="subtitle bold">
                {{ "forms.channel.advanced.labels.unit" | translate }}
            </div>
            <div>
                <app-labelled-block-input-wrapper
                    header="{{
                        'forms.channel.advanced.labels.unit' | translate
                    }}"
                >
                    <input
                        class="text"
                        type="text"
                        #wrapTarget
                        [(ngModel)]="editedChannel.opsData.measurementUnit"
                    />
                </app-labelled-block-input-wrapper>
            </div>
        </div>

        <!-- Normal Range -->
        <div class="input-group" *ngIf="!isDigital()">
            <!-- Normal Range Min -->
            <div class="subtitle bold">
                {{ "forms.channel.advanced.labels.normal-range" | translate }}
            </div>
            <div>
                <app-labelled-block-input-wrapper
                    header="{{
                        'forms.channel.advanced.labels.normal-range-minimum'
                            | translate
                    }}"
                >
                    <input
                        class="text"
                        type="text"
                        #wrapTarget
                        scaledNumericInput
                        (onScaledInput)="handleInputChange()"
                        [scale]="getScale()"
                        [(scaleValue)]="editedChannel.fcuData.normalRange.min"
                        [fixedScale]="true"
                    />
                </app-labelled-block-input-wrapper>
            </div>
            <app-validation-error-label
                *ngIf="getNormalRangeMinErrorString()"
                [message]="getNormalRangeMinErrorString()"
            ></app-validation-error-label>

            <!-- Normal Range Max -->
            <div>
                <app-labelled-block-input-wrapper
                    (onInput)="handleInputChange()"
                    header="{{
                        'forms.channel.advanced.labels.normal-range-maximum'
                            | translate
                    }}"
                >
                    <input
                        class="text"
                        type="text"
                        #wrapTarget
                        scaledNumericInput
                        (onScaledInput)="handleInputChange()"
                        [scale]="getScale()"
                        [(scaleValue)]="editedChannel.fcuData.normalRange.max"
                        [fixedScale]="true"
                    />
                </app-labelled-block-input-wrapper>
            </div>

            <app-validation-error-label
                *ngIf="getNormalRangeMaxErrorString()"
                [message]="getNormalRangeMaxErrorString()"
            ></app-validation-error-label>
        </div>

        <!-- Alarm Settings (Digital) -->
        <div *ngIf="isDigital()">
            <!-- Digital Alarm Settings -->
            <app-form-accordion
                #accordions
                #digitalAccordion
                [header]="
                    'forms.channel.alarm.alarm-labels.digital' | translate
                "
                [showErrorBorder]="true"
            >
                <app-alarm-setting-form
                    [validator]="getAlarmValidatorAlarmSetting()"
                    title="channel.label.alarm.digital"
                    [disableFields]="['setPoint', 'timer']"
                    [alarm]="editedChannel.fcuData.digitalAlarmSetting"
                    [measurementUnits]="editedChannel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('digitalAlarmSetting', $event)"
                    (onDelete)="emitDelete('digitalAlarmSetting', $event)"
                    [channel]="editedChannel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </app-form-accordion>
        </div>

        <!-- Alarm settings (Analog) -->
        <div *ngIf="!isDigital()" class="input-group">
            <!-- Very High Alarm -->
            <app-form-accordion
                #accordions
                #veryHighAccordion
                [header]="
                    'forms.channel.alarm.alarm-labels.very-high' | translate
                "
                [showErrorBorder]="shouldShowErrorBorder(veryHighAlarmForm)"
            >
                <app-alarm-setting-form
                    [validator]="getAlarmValidatorVeryHigh()"
                    title="channel.label.alarm.high-high"
                    [disableFields]="['timer']"
                    [alarm]="editedChannel.fcuData.alarmSettingVeryHigh"
                    [measurementUnits]="editedChannel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingVeryHigh', $event)"
                    (onDelete)="emitDelete('alarmSettingVeryHigh', $event)"
                    [channel]="editedChannel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </app-form-accordion>

            <!-- High Alarm -->
            <app-form-accordion
                #accordions
                #highAccordion
                [header]="'forms.channel.alarm.alarm-labels.high' | translate"
                [showErrorBorder]="shouldShowErrorBorder(highAlarmForm)"
            >
                <app-alarm-setting-form
                    [validator]="getAlarmValidatorHigh()"
                    title="channel.label.alarm.high"
                    [disableFields]="['timer']"
                    [alarm]="editedChannel.fcuData.alarmSettingHigh"
                    [measurementUnits]="editedChannel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingHigh', $event)"
                    (onDelete)="emitDelete('alarmSettingHigh', $event)"
                    [channel]="editedChannel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </app-form-accordion>

            <!-- Low Alarm -->
            <app-form-accordion
                #accordions
                #lowAccordion
                [header]="'forms.channel.alarm.alarm-labels.low' | translate"
                [showErrorBorder]="shouldShowErrorBorder(lowAlarmForm)"
            >
                <app-alarm-setting-form
                    [validator]="getAlarmValidatorLow()"
                    title="channel.label.alarm.low"
                    [disableFields]="['timer']"
                    [alarm]="editedChannel.fcuData.alarmSettingLow"
                    [measurementUnits]="editedChannel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingLow', $event)"
                    (onDelete)="emitDelete('alarmSettingLow', $event)"
                    [channel]="editedChannel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </app-form-accordion>

            <!-- Very Low Alarm -->
            <app-form-accordion
                #accordions
                #veryLowAccordion
                [header]="
                    'forms.channel.alarm.alarm-labels.very-low' | translate
                "
                [showErrorBorder]="shouldShowErrorBorder(veryLowAlarmForm)"
            >
                <app-alarm-setting-form
                    [validator]="getAlarmValidatorVeryLow()"
                    title="channel.label.alarm.low-low"
                    [disableFields]="['timer']"
                    [alarm]="editedChannel.fcuData.alarmSettingVeryLow"
                    [measurementUnits]="editedChannel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingVeryLow', $event)"
                    (onDelete)="emitDelete('alarmSettingVeryLow', $event)"
                    [channel]="editedChannel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </app-form-accordion>

            <!-- Feedback Error Alarm -->
            <app-form-accordion
                #accordions
                #feedbackErrorAccordion
                [header]="
                    'forms.channel.alarm.alarm-labels.feedback' | translate
                "
                [showErrorBorder]="
                    shouldShowErrorBorder(feedbackErrorAlarmForm)
                "
            >
                <app-alarm-setting-form
                    [validator]="getAlarmValidatorFeedback()"
                    title="channel.label.alarm.feedback"
                    [isFeedbackAlarm]="true"
                    [disableFields]="['setPoint']"
                    [alarm]="editedChannel.fcuData.alarmSettingFeedbackError"
                    [measurementUnits]="editedChannel.opsData.measurementUnit"
                    (onSubmit)="emitSubmit('alarmSettingFeedbackError', $event)"
                    (onDelete)="emitDelete('alarmSettingFeedbackError', $event)"
                    [channel]="editedChannel"
                    [userPermission]="userPermission"
                ></app-alarm-setting-form>
            </app-form-accordion>
        </div>

        <!-- Input -->
        <div class="input-group">
            <div class="subtitle bold">
                {{ "forms.channel.advanced.labels.input" | translate }}
            </div>
            <div class="spinner-container">
                <div>
                    <app-ops-spinner-input
                        title="{{
                            'forms.channel.advanced.labels.fu-no' | translate
                        }}"
                        [min]="MIN_FU_NO"
                        [max]="MAX_FU_NO"
                        [(value)]="
                            editedChannel.fcuData.inputData.fuInputAddress.fuNo
                        "
                    >
                    </app-ops-spinner-input>
                </div>
                <div>
                    <app-ops-spinner-input
                        title="{{
                            'forms.channel.advanced.labels.slot-no' | translate
                        }}"
                        [min]="MIN_SLOT_NO"
                        [max]="MAX_SLOT_NO"
                        [(value)]="
                            editedChannel.fcuData.inputData.fuInputAddress
                                .slotNo
                        "
                    >
                    </app-ops-spinner-input>
                </div>
                <div>
                    <app-ops-spinner-input
                        title="{{
                            'forms.channel.advanced.labels.pin-no' | translate
                        }}"
                        [min]="MIN_PIN_NO"
                        [max]="MAX_PIN_NO"
                        [(value)]="
                            editedChannel.fcuData.inputData.fuInputAddress.pin
                        "
                    >
                    </app-ops-spinner-input>
                </div>
            </div>

            <!-- Channel Type -->
            <div class="input-box">
                <app-labelled-block-input-wrapper
                    [header]="
                        'forms.channel.advanced.labels.channel-type' | translate
                    "
                >
                    <mat-select
                        class="text-large"
                        #wrapTarget
                        style="margin: 0px; padding: 0px"
                        [(ngModel)]="editedChannel.fcuData.channelType"
                    >
                        <mat-option
                            *ngFor="let label of channelTypeLabels"
                            [value]="typeValueLookup[label]"
                        >
                            {{ label }}
                        </mat-option>
                    </mat-select>
                </app-labelled-block-input-wrapper>
            </div>
        </div>

        <!-- Output -->
        <div class="input-group">
            <div class="subtitle bold">
                {{ "forms.channel.advanced.labels.output" | translate }}
            </div>
            <div>
                <app-labelled-block-input-wrapper
                    header="{{
                        'forms.channel.advanced.labels.signal-type' | translate
                    }}"
                >
                    <input
                        class="text"
                        type="text"
                        #wrapTarget
                        (ngModelChange)="handleInputChange()"
                        placeholder="*"
                        disabled
                    />
                </app-labelled-block-input-wrapper>
            </div>
            <div>
                <app-labelled-block-input-wrapper
                    header="{{
                        'forms.channel.advanced.labels.output-data' | translate
                    }}"
                >
                    <input
                        class="text"
                        type="text"
                        #wrapTarget
                        (ngModelChange)="handleInputChange()"
                        placeholder="*"
                        disabled
                    />
                </app-labelled-block-input-wrapper>
            </div>
        </div>

        <!-- Mimics -->
        <div class="advanced-group">
            <div class="subtitle bold">
                {{ "forms.channel.advanced.labels.mimics.header" | translate }}
            </div>
            <div class="text">
                {{
                    "forms.channel.advanced.labels.mimics.description"
                        | translate
                }}
            </div>
            <div *ngFor="let mimic of getMimics()" class="mimics-container">
                <div class="mimic-names">
                    <div class="text-large">
                        {{ mimic.name }}
                    </div>
                </div>
                <div>
                    <button class="border" (click)="onEditMimic()">
                        {{ "forms.channel.advanced.button.mimics" | translate }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Trend Graphs -->
        <div class="advanced-group">
            <div class="subtitle bold">
                {{
                    "forms.channel.advanced.labels.trend-graph.header"
                        | translate
                }}
            </div>
            <div>
                <!-- Graphs this channel is in -->
                <app-bubble-item-list
                    [options]="getActiveGraphs()"
                    [extractLabelFn]="getGraphLabel"
                    (onRemoveElement)="handleRemoveGraphClicked($event)"
                ></app-bubble-item-list>

                <!-- Add to graphs button -->
                <div
                    class="caption-small trend-graph-label-button"
                    (click)="showInactiveGraphs()"
                    style="cursor: pointer"
                >
                    <mat-icon class="add-icon" svgIcon="blue-add"></mat-icon>
                    <span class="highlighted">
                        {{
                            "forms.channel.advanced.labels.trend-graph.add"
                                | translate
                        }}
                    </span>
                </div>
            </div>

            <!-- Add graphs selector -->
            <div [hidden]="!isAddingGraphs()">
                <!-- Selected Graph Errors -->
                <div>
                    <div
                        *ngFor="let error of fullGraphErrors"
                        class="error text-small"
                    >
                        <p>
                            <mat-icon svgIcon="error"></mat-icon>
                            {{ error.errorString }}
                        </p>
                    </div>
                </div>

                <!-- Graph Selection -->
                <app-bubble-selector
                    #graphBubbleSelector
                    [options]="getInactiveGraphs()"
                    [extractLabelFn]="getGraphLabel"
                    (onSelectionChange)="handleGraphSelectionChanged($event)"
                ></app-bubble-selector>

                <!-- Create New Graph Button -->
                <div
                    style="cursor: pointer"
                    class="caption-small trend-graph-label-button"
                    (click)="handleCreateGraphClicked()"
                >
                    <mat-icon class="add-icon" svgIcon="blue-add"></mat-icon>
                    <span class="highlighted">
                        {{
                            "forms.channel.advanced.labels.trend-graph.create"
                                | translate
                        }}
                    </span>
                </div>

                <!-- Submit Graph Selections Button -->
                <button
                    class="primary caption-small"
                    style="width: 240px; cursor: pointer"
                    (click)="handleAddGraphsClicked()"
                    [disabled]="fullGraphErrors.length"
                >
                    {{
                        "forms.channel.advanced.labels.trend-graph.confirm-selection"
                            | translate
                    }}
                </button>
            </div>
        </div>
    </div>
</div>

<app-pop-up-notification
    #notification
    [message]="'dlg.channels.advanced.notification.msg'"
    [closeButton]="'dlg.channels.advanced.notification.close'"
    [ngClass]="getNotificationVisible() ? 'show' : ''"
></app-pop-up-notification>
